export default __webpack_public_path__ + "static/media/tripod.11963e08.svg";